import axios from 'axios'

const formatApiError = (value) => {
	if (value == null) return 'Unknown error'
	if (typeof value === 'string') return value
	if (value instanceof Error) return value.message || String(value)

	if (typeof value === 'object') {
		const parts = []
		if (value.error && typeof value.error === 'string') parts.push(value.error)
		else if (value.message && typeof value.message === 'string') parts.push(value.message)

		if (value.errors && typeof value.errors === 'object') {
			for (const [field, messages] of Object.entries(value.errors)) {
				const list = Array.isArray(messages) ? messages : [messages]
				for (const msg of list) {
					parts.push(`${field}: ${msg}`)
				}
			}
		}

		if (parts.length) return parts.join('\n')

		try {
			return JSON.stringify(value)
		} catch {
			return String(value)
		}
	}

	return String(value)
}

const extractError = (error) => {
	if (error?.response?.data !== undefined) {
		return formatApiError(error.response.data)
	}
	return formatApiError(error)
}

class Axhelper {
	sendGet = async (url, cb) => {
		const token = localStorage.getItem('token');
		await axios.get(url, { withCredentials: true, headers: { 'token': token } }).then(
			resp => {
				cb(null, resp.data)
			},
			error => {
				cb(extractError(error), null)
			}
		)
	}

	sendGetAsync = async url => {
		let errorMessage = null
		const token = localStorage.getItem('token');
		const response = await axios.get(url, { withCredentials: true, headers: { 'token': token } }).catch(error => {
			errorMessage = extractError(error)
			return null
		})

		return { error: errorMessage, headers: response?.headers?.toJSON?.(), data: response?.data }
	}

	sendGetUserPassword = async (url, user, password, cb) => {
		await axios
			.get(
				url,
				{ withCredentials: true },
				{
					auth: {
						username: user,
						password: password,
					},
				}
			)
			.then(
				resp => {
					cb(null, resp.data)
				},
				error => {
					cb(extractError(error), null)
				}
			)
	}

	sendDelete = async (url, cb) => {
		const token = localStorage.getItem('token');
		await axios.delete(url, { withCredentials: true, headers: { 'token': token } }).then(
			resp => {
				cb(null, resp.data)
			},
			error => {
				cb(extractError(error), null)
			}
		)
	}

	sendDeleteAsync = async url => {
		let errorMessage = null
		const token = localStorage.getItem('token');
		const response = await axios.delete(url, { withCredentials: true, headers: { 'token': token } }).catch(error => {
			errorMessage = extractError(error)
			return null
		})
		return { error: errorMessage, headers: response?.headers?.toJSON?.(), data: response?.data }
	}

	sendPost = async (url, data, cb) => {
		const token = localStorage.getItem('token');
		await axios.post(url, data, { withCredentials: true, headers: { 'token': token } }).then(
			resp => {
				cb(null, resp.data)
			},
			error => {
				cb(extractError(error), null)
			}
		)
	}

	sendPostAsync = async (url, data) => {
		let errorMessage = null
		const token = localStorage.getItem('token');
		const response = await axios.post(url, data, { withCredentials: true, headers: { 'token': token } }).catch(error => {
			errorMessage = extractError(error)
			return null
		})

		return { error: errorMessage, headers: response?.headers?.toJSON?.(), data: response?.data }
	}

	sendUploadAsync = async (url, data, onUploadProgress) => {
		let errorMessage = null
		const token = localStorage.getItem('token');
		const response = await axios
			.post(url, data, {
				withCredentials: true,
				headers: { 'token': token },
				onUploadProgress: (progressEvent) => {
					if (onUploadProgress) onUploadProgress(progressEvent)
				}
			})
			.catch(error => {
				errorMessage = extractError(error)
				return null
			})

		return { error: errorMessage, headers: response?.headers?.toJSON?.(), data: response?.data, status: response?.status }
	}

	sendPut = async (url, data, cb) => {
		const token = localStorage.getItem('token');
		await axios.put(url, data, { withCredentials: true, headers: { 'token': token } }).then(
			resp => {
				cb(null, resp.data)
			},
			error => {
				cb(extractError(error), null)
			}
		)
	}

	sendPutAsync = async (url, data) => {
		let errorMessage = null
		const token = localStorage.getItem('token');
		const response = await axios.put(url, data, { withCredentials: true, headers: { 'token': token } }).catch(error => {
			errorMessage = extractError(error)
			return null
		})
		return { error: errorMessage, headers: response?.headers?.toJSON?.(), data: response?.data }
	}
}
export default new Axhelper()
